import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { useLoading } from '../hooks/useLoading';
import { Topbar } from '../components/Topbar';
import { User, Mail, Shield, Save, Bell, Moon, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
import { Card, Button, Input, Skeleton } from '../components/ui';

export function SettingsPage() {
  const { user, updateUser } = useAuth();
  const { addToast } = useToast();
  const loading = useLoading(400);
  
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);

  const handleSave = (e) => {
    e.preventDefault();
    updateUser({ name, email });
    addToast('Configurações do perfil atualizadas!', 'success');
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <Topbar />
      <Card 
        title="Configurações do Perfil" 
        subtitle="Gerencie suas informações pessoais e preferências de conta."
        className="fullPage"
      >
        <div className="settingsGrid mt-6">
          {loading ? (
            <>
              <Skeleton className="h-[300px] rounded-3xl" />
              <div className="flex flex-col gap-4">
                <Skeleton className="h-[140px] rounded-3xl" />
                <Skeleton className="h-[140px] rounded-3xl" />
              </div>
            </>
          ) : (
            <>
              <form className="formCard" onSubmit={handleSave}>
                <h3 className="text-lg font-bold mb-4">Informações Pessoais</h3>
                <Input 
                  label="Nome Completo"
                  icon={User}
                  value={name} 
                  onChange={e => setName(e.target.value)} 
                />
                <Input 
                  label="E-mail Acadêmico"
                  icon={Mail}
                  value={email} 
                  onChange={e => setEmail(e.target.value)} 
                />
                <Button type="submit" className="mt-4 flex items-center gap-2">
                  <Save size={16}/> Salvar Alterações
                </Button>
              </form>

              <div className="flex flex-col gap-4">
                <div className="formCard">
                  <h3 className="text-lg font-bold mb-4">Segurança</h3>
                  <div className="settingItem">
                    <div>
                      <strong className="block text-sm">Alterar Senha</strong>
                      <span className="text-xs text-muted">Recomendamos uma senha forte de 8+ caracteres.</span>
                    </div>
                    <Button variant="outline" size="sm"><Lock size={14} className="mr-2"/> Alterar</Button>
                  </div>
                  <div className="settingItem">
                    <div>
                      <strong className="block text-sm">Autenticação em Duas Etapas</strong>
                      <span className="text-xs text-muted">Adicione uma camada extra de segurança.</span>
                    </div>
                    <Button variant="outline" size="sm">Ativar</Button>
                  </div>
                </div>

                <div className="formCard">
                  <h3 className="text-lg font-bold mb-4">Preferências</h3>
                  <div className="settingItem">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-purple/10 rounded-lg"><Bell size={18} className="text-purple"/></div>
                      <strong className="text-sm">Notificações por E-mail</strong>
                    </div>
                    <input type="checkbox" defaultChecked className="w-5 h-5 accent-purple" />
                  </div>
                  <div className="settingItem">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-purple/10 rounded-lg"><Moon size={18} className="text-purple"/></div>
                      <strong className="text-sm">Modo Noturno Automático</strong>
                    </div>
                    <input type="checkbox" defaultChecked className="w-5 h-5 accent-purple" />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </Card>
    </motion.div>
  );
}
